import Data from '../../common/data';
import { popMgr } from '@/components/global';
import axios from 'axios';

const styleMap = {
    standard: () =>
        import(
            /* webpackChunkName: "common/questionnaire/standard"*/ './standard.vue'
        )
};

const psMap = {};

const vow = {
    prepare(style) {
        if (!psMap[style]) {
            let mappedStyle = styleMap[style] || styleMap.standard;
            psMap[style] = mappedStyle();
        }
        return psMap[style];
    },
    activate() {
        axios
            .get('/api-site/vow-listings/is-activated?t=' + Date.now())
            .then(({ data }) => {
                if (!data.isVowListingActivated) {
                    this.open(
                        {
                            hasSentEmail: !!data.vowListingActiveMailNum
                        },
                        1
                    );
                }
            });
    },
    open(options = {}, type = 0, callback, style) {
        style = style || Data.registration.style || 'standard';
        const ps = [this.prepare(style)];
        // if (type === 0) {
        //     ps.push(axios.get('/api-site/vow-listings/get-contract'));
        // }
        Promise.all(ps).then(([pop, res]) => {
            let data = type === 0 && res ? res.data : {};
            const vdata = {
                name: 'vow',
                type,
                options: Object.assign(data, options)
            };
            var ins = popMgr.create(pop.default, vdata);
            ins.$once('beforeDestroy', callback);
        });
    }
};

export default vow;
